export default {
    general: {
        cancel: 'Prekliči',
        close: 'Zapri',
        send: 'Pošlji',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
    },
    success: {
        request_sent: 'Hvala — pokličemo vas v kratkem.',
    },
    validation: {
        required: 'To polje je obvezno',
        phone: 'Vnesite veljavno telefonsko številko',
    },
}
